import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileApiService {

  protected apiUrl = environment.apiUrl+'v1/files';

  constructor(private httpClient: HttpClient) { }

  public findByPath(path: string): Observable<Blob> {
    return this.httpClient.post(
      `${this.apiUrl}?path=${path}`, 
      {},
      { responseType: 'blob' }
    );
  }

}
